import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import SliderCard from "../SliderCard";
import "./styles.scss";

const LoanDisbursementCard = ({
  disbursementHeading,
  disbursementDescription,
  valueSuffix,
  labelSuffix,
  value,
  onChange,
  minValue,
  maxValue,
  cardData,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  return (
    <div className="loan-disbursement-card-container">
      <p className="loan-disbursement-card-heading">{disbursementHeading}</p>
      <p className="loan-disbursement-card-description">
        {disbursementDescription}
      </p>
      {/* <SliderCard
        value={value}
        valueSuffix={valueSuffix}
        onChange={onChange}
        minValue={minValue}
        maxValue={maxValue}
        labelSuffix={labelSuffix}
      /> */}
      <div className="loan-disbursement-card-details-card">
        {cardData?.map((item) => (
          <div className="loan-disbursement-card-details-card-item">
            <p className="loan-disbursement-card-details-card-label">
              {t(`${routeName}.${item?.label}`)}
            </p>
            <p className="loan-disbursement-card-details-card-value">
              {item?.value}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoanDisbursementCard;
